/* global BRAND, OVERRIDED_COMPONENTS */
/* eslint-disable react/no-did-mount-set-state, global-require, import/no-dynamic-require */

import React from 'react'

export const BrandedComponentsList = {
  LoginLayout: 'LoginLayout.js',
  GlobalLoading: 'GlobalLoading.js',
  LocalLoading: 'LocalLoading.js',
}

const cache = {}

export const loadBrandedComponent = async (name) => {
  if (cache[name]) {
    return cache[name]
  }

  let component

  if (OVERRIDED_COMPONENTS.includes(name)) {
    component = await import(`../../../brands/${BRAND}/components/${name}`)
  } else {
    component = await import(`./brandedComponents/${name}`)
  }

  cache[name] = component.default

  return component.default
}

class BrandedComponentLoader extends React.Component {
  state = {
    ComponentToRender: null,
  }

  componentDidMount() {
    this.ismounted = true

    loadBrandedComponent(this.props.component).then((ComponentToRender) => {
      if (this.ismounted) {
        this.setState({ ComponentToRender })
      }
    })
  }

  componentWillUnmount() {
    this.ismounted = false
  }

  render() {
    const { ComponentToRender } = this.state
    const { component, ...rest } = this.props

    if (!ComponentToRender) {
      return null
    }

    return <ComponentToRender {...rest} />
  }
}

export default BrandedComponentLoader
